import { useNavigate } from 'react-router-dom';

import { UsersContext } from 'contexts/UsersContext';

import { Manage } from 'sections/Manage';

import { LoadingWrapper } from 'components/LoadingWrapper';
import { DeleteModal } from 'components/DeleteModal';

import { routes } from 'data/routes';
import { generateTabs } from './tabs.data';
import { useEdit } from './Edit.hooks';

export function Edit(): React.ReactElement {
  const { isShippingAddress, isLoading, values, id, existingUserId, existingUserIdSet } =
    useEdit();
  const navigate = useNavigate();

  return (
    <UsersContext.Provider value={values}>
      <LoadingWrapper isLoading={isLoading}>
        {existingUserId.length && !id ? (
          <DeleteModal
            customText="User with this email already exists, want to go to it?"
            onClose={() => existingUserIdSet('')}
            onDelete={() => {
              existingUserIdSet('');
              navigate(routes.userView(existingUserId));
            }}
          />
        ) : null}
        <Manage title="Users" tabs={generateTabs(id, isShippingAddress)} />
      </LoadingWrapper>
    </UsersContext.Provider>
  );
}
